import { Dispatch } from 'react';
import { PromoCodeFilters, PromoCodeModel } from '../../../api/pricing/pricing.types';
import {
  GET_PROMO_CODES_LIST,
  GET_PROMO_CODE,
  PUT_PROMO_CODE,
  POST_PROMO_CODE,
  DELETE_PROMO_CODE,
  DeletePromoCodeAction,
  UpdatePromoCodeFiltersAction,
  UPDATE_PROMO_CODE_FILTERS
} from '../types/promocode.types';
import { PricingApi } from '../../../api/api.apiclient';
import { PageRequest } from '../../../api/api.types';

export const getPromoCodesList = (filters?: PromoCodeFilters, page?: PageRequest) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.PromoCodes.listAllPromoCodes(filters, page);

  dispatch({
    type: GET_PROMO_CODES_LIST,
    payload: {
      page: response.data
    }
  });
  return Promise.resolve();
};

export const getPromoCode = (code: string) => async (dispatch: Dispatch<any>): Promise<any> => {
  try {
    const response = await PricingApi.PromoCodes.getOnePromoCode(code);

    dispatch({
      type: GET_PROMO_CODE,
      payload: {
        selectedPromoCode: response.data
      }
    });

    return Promise.resolve();
  } catch (e) {
    dispatch({
      type: GET_PROMO_CODE,
      payload: {
        selectedPromoCode: null
      }
    });

    return Promise.reject();
  }
};

export const editPromoCode = (code: string, request: PromoCodeModel) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.PromoCodes.editPromoCode(code, request);

  dispatch({
    type: PUT_PROMO_CODE,
    payload: {
      selectedPromoCode: response.data
    }
  });
};

export const addNewPromoCode = (request: PromoCodeModel) => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.PromoCodes.addNewPromoCode(request);

  dispatch({
    type: POST_PROMO_CODE,
    payload: {
      newPromoCode: response.data,
      success: true
    }
  });
};

export const deletePromoCode = (code: string) => async (dispatch: Dispatch<DeletePromoCodeAction>) => {
  await PricingApi.PromoCodes.deletePromoCode(code);
  dispatch({
    type: DELETE_PROMO_CODE,
    payload: {
      success: true
    }
  });
};

export const UpdatePromoCodeFilters = (filters: PromoCodeFilters) => async (dispatch: Dispatch<UpdatePromoCodeFiltersAction>) => {
  dispatch({
    type: UPDATE_PROMO_CODE_FILTERS,
    payload: {
      filters
    }
  });
};
